import { SupportedLanguage, SupportedAccent } from "../ruleSets/allRules";
import { SpeakVariant } from "../speak/meSpeak";

/** a single part to speak, made of words, language settings, & voice options */
export interface SpeakingPart {
  readonly words: string;
  readonly language?: PartLanguage;
  readonly options?: PartOptions;
}

/** language & optional accent to use */
export interface PartLanguage {
  language: SupportedLanguage;
  accent?: SupportedAccent;
}

export const languageParts = ['language', 'accent'];

/** voice settings to use */
export interface PartOptions {
  /** variant, e.g., 'fiona', 'm5' */
  voice?: SpeakVariant;
  /** amplitude, default: 100 */
  volume?: number;
  /** voice pitch, default: 50 */
  pitch?: number;
  /** words per minute, default: 175 */
  speed?: number;
  /** additional 10 ms gaps between words, default: 0 */
  wordgap?: number;
  /** stereo panning in (-1..1), from extreme left to right, default: 0 */
  pan?: number;
}

export const optionsParts = ['volume', 'pitch', 'speed', 'voice', 'wordgap', 'pan'];
